module.exports = __webpack_public_path__ + "img/up-active.e9650a9.png";